(function () {
  function getCurrentVariantId() {
    var variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]:checked') ||
                       document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
                       document.querySelector('[data-selected-variant-id]');

    if (variantInput) {
      return variantInput.value || variantInput.getAttribute('data-selected-variant-id');
    }

    var productForm = document.querySelector('product-form');
    if (productForm && productForm.currentVariant) {
      return productForm.currentVariant.id.toString();
    }

    return null;
  }

  // Swym only binds buttons present when it loads, so swapped-in PDP markup needs binding again.
  function initSwym(swat) {
    var buttons = document.querySelectorAll('.swym-add-to-wishlist:not(.swym-loaded)');
    buttons.forEach(function (btn) {
      var parent = btn.parentNode;

      var currentVariantId = getCurrentVariantId();
      if (currentVariantId && btn.getAttribute('data-variant-id') !== currentVariantId) {
        btn.setAttribute('data-variant-id', currentVariantId);
        btn.setAttribute('data-empi', currentVariantId);
      }

      if (typeof swat.initializeActionButtons === 'function') {
        if (!parent.id) {
          parent.id = 'swym-reinit-' + Math.random().toString(36).substr(2, 9);
        }
        try {
          swat.initializeActionButtons('#' + parent.id);
        } catch (e) {
          console.error('duskWishlist: Failed to re-init', e);
        }
      }
    });
  }

  window.duskWishlist = {
    refresh: function () {
      setTimeout(function () {
        if (window._swat) {
          initSwym(window._swat);
        } else if (window.SwymCallbacks) {
          window.SwymCallbacks.push(initSwym);
        }
      }, 100);
    }
  };

  document.addEventListener('product:swapped', function () {
    window.duskWishlist.refresh();
  });

  document.addEventListener('variant:change', function (e) {
    var wishlistButton = document.querySelector('.swym-add-to-wishlist[data-variant-id]');
    if (wishlistButton && e.detail && e.detail.variant) {
      wishlistButton.setAttribute('data-variant-id', e.detail.variant.id);
      wishlistButton.setAttribute('data-empi', e.detail.variant.id);
    }
  });
})();
